module.exports = __webpack_public_path__ + "img/Z61_15.3f392d76.jpg";